import { IApiService } from 'web_core_library';
import { IFullAchievementsData, PartialAchievementsData } from './types';

export function createAchievementsService() {
  let ApiService: IApiService;

  /**
   * this call returns all achievements for given user
   * no filter is supported at the time of implementation
   */
  const getUserAchievements = () => {
    return ApiService.action<IFullAchievementsData>('training_achievements', {
      method: 'get',
      urlParams: {
        userId: ApiService.getUserId(),
      },
    });
  };

  /**
   * call saving new achievements to the backend
   * @param achievements all new achievements needed to be saved to backend
   */
  const saveUserAchievements = (achievements: PartialAchievementsData) => {
    return ApiService.action('training_achievements', {
      method: 'post',
      urlParams: {
        userId: ApiService.getUserId(),
      },
      data: achievements,
    });
  };

  const service = {
    init: (ApiServiceInstance: IApiService) => {
      ApiService = ApiServiceInstance;
    },
    getUserAchievements,
    saveUserAchievements,
  };
  return service;
}

const AchievementsService = createAchievementsService();
export default AchievementsService;
